export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_FETCH_DATA = 'GET_FETCH_DATA'
export const LAST_UNPAID_INVOICE = 'LAST_UNPAID_INVOICE'
export const PLUGIN_USE_COUNT = 'PLUGIN_USE_COUNT'
export const LAST_PAID_INVOICE = 'LAST_PAID_INVOICE'
export const GET_TABLE_DATA = 'GET_TABLE_DATA'
